export const locale = {
  search: 'Search',
};
